import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {FabMessageService} from '@fabric/components/message';
import {FabThemeService} from '@fabric/components/theme';
import {AdminService} from './admin.service';
import {Team} from './models/team.model';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

    @ViewChild(MatPaginator) paginator: MatPaginator | undefined;

    public isPageLoading = true;

    public teams: Team[] = [];

    constructor(private readonly adminService: AdminService,
                private readonly messageService: FabMessageService,
                public readonly themeService: FabThemeService) {
    }

    ngOnInit() {
        this.adminService.fetchAllTeams().subscribe({
            next: (data) => {
                this.teams = data;
                this.isPageLoading = false;
            },
            error: () => this.messageService.displayErrorMessage('Error fetching data')
        });
    }
}
